import { BsArrowDownUp, BsSortDown, BsSortUp } from 'react-icons/bs'
import cn from 'clsx'

const Th = ({
    slug,
    label,
    sortable,
    onHeaderClick,
    orderField,
    orderDirection,
    style,
    className,
}) => (
    
    <th
        style={style}
        onClick={sortable ? () => onHeaderClick(slug) : () => {}}>
        
        <div className={cn('flex gap-1 items-center', { 'cursor-pointer': sortable }, className)}>
            
            <span>{label}</span>
            
            {sortable && orderField === slug && (
                orderDirection === 'DESC'
                    ? <BsSortDown className="min-w-[16px] min-h-[16px]" />
                    : <BsSortUp className="min-w-[16px] min-h-[16px]" />
            )}
            
            {sortable && orderField !== slug && <BsArrowDownUp className="min-w-[16px]" />}
        
        </div>
    
    </th>
    
)

export default Th
